import { createApp } from "vue";
import App from "./App.vue";
import globalMixin from "./globalMixin.js";
import router from "./router/index.js";
import store from "./store/index.js";
import "./styles/app.scss";

if (location.host.slice(0, 2) == "en") {
	console.log("en");
	window.api_url = "https://en.bestphonekosher.com/api_vue/";
} else {
	console.log("he");
	window.api_url = "https://bestphonekosher.com/api_vue/";
}
window.task_api = "https://bestphonekosher.com/api_tasks/";
const app = createApp({
	extends: App,
})
	.use(store)
	.use(router);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt, faShoppingCart, faTimes } from "@fortawesome/free-solid-svg-icons";
library.add(faTrashAlt, faShoppingCart, faTimes);
app.component("FontAwesomeIcon", FontAwesomeIcon);

import axios from "axios";
import VueAxios from "vue-axios";
app.use(VueAxios, axios);

import SignaturePad from "vue3-signature-pad";
app.use(SignaturePad);

import VueCreditCardValidation from "vue-credit-card-validation";
app.use(VueCreditCardValidation);

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
app.use(VueSweetalert2);

app.mixin(globalMixin);
app.mount("#app");
